import allDefinition from './all.js';
import enabledDefinition from './enabled.js';
import notAvailableBuiltInDefinition from './not-available-built-in.js';

const selectorDefinitions = [
  allDefinition,
  enabledDefinition,
  notAvailableBuiltInDefinition,
];

export default selectorDefinitions;
